import { Promoter } from './../../models/FirstPromoter';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireAction } from 'angularfire2/database';
import { User, Subscription } from '../../models/User';
import { DataSnapshot } from '../../../node_modules/@firebase/database-types';

@Injectable()
export class AdminProvider {

  constructor(private db: AngularFireDatabase) {
  }

  public getUsers(): Observable<User[]>{
    let path = `users`;
    let list = this.db.list<User>(path);
    return list.valueChanges();
  }

  public getSubscriptions(): Observable<AngularFireAction<DataSnapshot>[]>{
    let path = `subscriptions`;
    let list = this.db.list<Subscription>(path);
    return list.snapshotChanges();
  }

  public getPromoters(): Observable<AngularFireAction<DataSnapshot>[]>{
    let path = `promoters`;
    let list = this.db.list<Promoter>(path);
    return list.snapshotChanges();
  }

  public getAdminUids(): Observable<string[]>{
    return this.db.object(`admins`).valueChanges().map(keys => {
      let arr: string[] = [];
      for(let key in keys){
        arr.push(key);
      }
      return arr;
    })
  }

  public addAdmin(uid: string){
    this.db.object(`admins/${uid}`).set(true);
  }

  public removeAdmin(uid: string){
    this.db.list(`admins`).remove(uid);
  }

  public getPayments(uid: string): Observable<any[]>{
    let path = `/stripeInvoices/${uid}`;
    let list = this.db.list<any>(path);
    return list.valueChanges();
  }

  public getSubscription(uid: string): Observable<Subscription>{
    let path = `/subscriptions/${uid}`;
    let obj = this.db.object<Subscription>(path);
    return obj.valueChanges();
  }

  public setPro(uid: string, value: boolean){
    let path = `/subscriptions/${uid}`;
    let payload = {status: value ? 'PRO' : 'INACTIVE'};
    if(value){
      this.db.object(`settings/${uid}`).update({
        enablePushNotificationsSignals: true,
        enablePushNotificationsGrades: true,
        enablePushNotificationsReports: true,
    
        enablePushNotificationsSignalsStocks: true,
        enablePushNotificationsGradesStocks: true,
        enablePushNotificationsReportsStocks: true,
      
        enablePushNotificationsPulse: true,
        enablePushNotificationsStream: true,
      })
    }
    return this.db.object(path).update(payload);
  }
}



// WEBPACK FOOTER //
// ./src/providers/admin/admin.ts